import {
  CreateTeamRequest,
  CreateTeamResponse,
  PasswordResetRequest,
  PasswordResetResponse,
  StatusUpdateRequest,
  StatusUpdateResponse,
  UpdateTeamRequest,
} from "../@types";
import axiosInstance from "./axios-instance";
import { Team } from "../@types";
import { handleError } from "./utils";

/**
 * Creates a team
 */
export const createTeam = (team: CreateTeamRequest) =>
  axiosInstance.post<any>("/team/createTeam/", team).catch(handleError);

export const createNewTeam = (team: CreateTeamRequest) =>
  axiosInstance.post<any>("/team/createTeam/", team).catch(handleError);

/**
 * Gets a team by id
 */
export const getTeam = (id: string) =>{
  return axiosInstance
    .get<Team>("/team/getteam/id", { params: { id: id } })
    .catch(handleError);
}

export const getTeamMembers = (teamName: string) =>{
  return axiosInstance
    .get<Team>("/team/getteammembers/name", { params: { name: teamName } })
    .catch(handleError);
}

/**
 * Gets a page of teams
 */
export const getTeams = () =>
  axiosInstance.get<Team[]>(`/team/getallteams/`).catch(handleError);

/**
 * Updates a team by id
 */
export const updateTeam = (team: UpdateTeamRequest) =>
  axiosInstance.put<Team>("/team/updateTeam", team).catch(handleError);

/**
 * Deletes a team by id
 */
export const deleteTeam = (id: string) =>
  axiosInstance.delete('/team/deleteTeamById', { data: { id: id } })
  .catch(handleError);